// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BranchCard-module__branchCard__A9odf {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition:
    box-shadow 0.3s ease,
    transform 0.2s ease;
}

.BranchCard-module__branchCard__A9odf:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.BranchCard-module__branchHeader__cbPFy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.BranchCard-module__headerContent__Z86fj {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  gap: 1rem;
}

.BranchCard-module__branchName__yIbiB {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.BranchCard-module__departmentCount__mTTTj {
  font-size: 0.875rem;
  color: #666;
  background: #f5f5f5;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
}

.BranchCard-module__arrow__lmyCH {
  font-size: 0.75rem;
  color: #666;
  transition: transform 0.3s ease;
  margin-left: 1rem;
}

.BranchCard-module__arrowOpen__FITFE {
  transform: rotate(180deg);
}
.BranchCard-module__branchDetailsContainer__b1vk9 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.BranchCard-module__branchDetails__CvECk {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  animation: BranchCard-module__slideDown__QrgbB 0.3s ease;
  width: calc(70% - 1rem);
}

@keyframes BranchCard-module__slideDown__QrgbB {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}

.BranchCard-module__detailItem__uR5Ot {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.BranchCard-module__label__d7E0_ {
  font-size: 0.875rem;
  color: #666;
  font-weight: 500;
}

.BranchCard-module__value__xUln1 {
  font-size: 0.9375rem;
  color: #333;
}

.BranchCard-module__qrCode__hqDPA {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 30%;
}

.BranchCard-module__qrLoading__n5RA3 {
  font-size: 0.875rem;
  color: #666;
}

.BranchCard-module__qrError__SypAW {
  font-size: 0.875rem;
  color: #c62828;
}

.BranchCard-module__qrImage__PUR6h {
  max-width: 160px;
  height: auto;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BranchList/BranchCard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC;;uBAEqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,wDAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".branchCard {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition:\n    box-shadow 0.3s ease,\n    transform 0.2s ease;\n}\n\n.branchCard:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.branchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n  gap: 1rem;\n}\n\n.branchName {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.departmentCount {\n  font-size: 0.875rem;\n  color: #666;\n  background: #f5f5f5;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n}\n\n.arrow {\n  font-size: 0.75rem;\n  color: #666;\n  transition: transform 0.3s ease;\n  margin-left: 1rem;\n}\n\n.arrowOpen {\n  transform: rotate(180deg);\n}\n.branchDetailsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.branchDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  animation: slideDown 0.3s ease;\n  width: calc(70% - 1rem);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 500px;\n  }\n}\n\n.detailItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.label {\n  font-size: 0.875rem;\n  color: #666;\n  font-weight: 500;\n}\n\n.value {\n  font-size: 0.9375rem;\n  color: #333;\n}\n\n.qrCode {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #f0f0f0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  width: 30%;\n}\n\n.qrLoading {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.qrError {\n  font-size: 0.875rem;\n  color: #c62828;\n}\n\n.qrImage {\n  max-width: 160px;\n  height: auto;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branchCard": `BranchCard-module__branchCard__A9odf`,
	"branchHeader": `BranchCard-module__branchHeader__cbPFy`,
	"headerContent": `BranchCard-module__headerContent__Z86fj`,
	"branchName": `BranchCard-module__branchName__yIbiB`,
	"departmentCount": `BranchCard-module__departmentCount__mTTTj`,
	"arrow": `BranchCard-module__arrow__lmyCH`,
	"arrowOpen": `BranchCard-module__arrowOpen__FITFE`,
	"branchDetailsContainer": `BranchCard-module__branchDetailsContainer__b1vk9`,
	"branchDetails": `BranchCard-module__branchDetails__CvECk`,
	"slideDown": `BranchCard-module__slideDown__QrgbB`,
	"detailItem": `BranchCard-module__detailItem__uR5Ot`,
	"label": `BranchCard-module__label__d7E0_`,
	"value": `BranchCard-module__value__xUln1`,
	"qrCode": `BranchCard-module__qrCode__hqDPA`,
	"qrLoading": `BranchCard-module__qrLoading__n5RA3`,
	"qrError": `BranchCard-module__qrError__SypAW`,
	"qrImage": `BranchCard-module__qrImage__PUR6h`
};
export default ___CSS_LOADER_EXPORT___;
